import React, { Component } from 'react';
import Quagga from 'quagga';
import './Scanner.css';

export default class Scanner extends Component {
  constructor(props) {
    super(props);
    if (window.innerWidth > window.innerHeight) {
      this.state = { width: 640, height: 480 };
    } else {
      this.state = { height: 640, width: 480 };
    }
  }

  componentDidMount() {
    this.init();
    Quagga.onDetected(this.onDetected);
    Quagga.onProcessed(this.onProcessed);
    window.addEventListener('orientationchange', this.handleOrientationChange);
  }

  componentWillUnmount() {
    Quagga.offDetected(this.onDetected);
    Quagga.offProcessed(this.onProcessed);
    Quagga.stop();
    window.removeEventListener('orientationchange', this.handleOrientationChange);
  }

  init = () => {
    Quagga.init({
      inputStream: {
        type: 'LiveStream',
        constraints: {
          width: 640,
          height: 480,
          facing: 'environment', // or user
        },
      },
      locator: {
        patchSize: 'medium',
        halfSample: true,
      },
      numOfWorkers: 2,
      decoder: {
        readers: ['code_128_reader'],
        debug: {
          drawScanline: true,
        },
      },
      locate: true,
    }, (err) => {
      if (err) {
        return console.log(err);
      }
      Quagga.start();
    });
  }

  handleOrientationChange = () => {
    // portrait
    if (window.innerHeight > window.innerWidth) {
      this.setState({ width: 480, height: 640 }, () => {
        Quagga.stop();
        this.init();
      });
    } else {
      this.setState({ width: 640, height: 480 }, () => {
        Quagga.stop();
        this.init();
      });
    }
  }


  onDetected = (result) => {
    this.props.onDetected && this.props.onDetected(result);
  }

  onProcessed = (result) => {
    const drawingCtx = Quagga.canvas.ctx.overlay;


    const drawingCanvas = Quagga.canvas.dom.overlay;

    if (result) {
      if (result.boxes) {
        drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width'), 10), parseInt(drawingCanvas.getAttribute('height'), 10));
        result.boxes.filter(box => box !== result.box).forEach((box) => {
          Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: 'green', lineWidth: 2 });
        });
      }

      if (result.box) {
        Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: '#00F', lineWidth: 2 });
      }

      if (result.codeResult && result.codeResult.code) {
        Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
      }
    }
  }

  render() {
    return (
      <div id="interactive" style={{ position: 'relative', width: `${this.state.width}px`, height: `${this.state.height}px` }} className="mx-auto viewport" />
    );
  }
}



// WEBPACK FOOTER //
// ./src/scanner/index.js